import {
  ExternalMeasurementTagSettings,
  GoogleTagManagerSetting,
} from 'backend';
import {
  EXTERNAL_MEASUREMENT_TAG_TYPE,
  MeasurementSettingHandledByGtag,
} from 'models';
import { handleGtag, handleGtm } from 'models';
import { useEffect } from 'react';

type UseExternalMeasurementTagPayload =
  | ExternalMeasurementTagSettings
  | undefined;

export const useExternalMeasurementTag = (
  payload: UseExternalMeasurementTagPayload
): void => {
  useEffect(() => {
    if (!payload) {
      return;
    }
    const { settings } = payload;
    const settingsHandlingByGtag: MeasurementSettingHandledByGtag[] = [];
    const settingsHandlingByGtm: GoogleTagManagerSetting[] = [];
    settings.forEach((setting) => {
      if (setting.type === EXTERNAL_MEASUREMENT_TAG_TYPE.GoogleTagManager) {
        settingsHandlingByGtm.push(setting);
      }
      if (
        setting.type === EXTERNAL_MEASUREMENT_TAG_TYPE.GoogleAnalytics4 ||
        setting.type === EXTERNAL_MEASUREMENT_TAG_TYPE.UniversalAnalytics
      ) {
        settingsHandlingByGtag.push(setting);
      }
    });
    handleGtag({
      settings: settingsHandlingByGtag,
    });
    handleGtm({
      settings: settingsHandlingByGtm,
    });
  }, [payload]);
};
